export const CREATE = 'Entity/Roles/CREATE'
export const CREATE_SUCCESS = 'Entity/Roles/CREATE_SUCCESS'
export const CREATE_FAILURE = 'Entity/Roles/CREATE_FAILURE'

export const DELETE = 'Entity/Roles/DELETE'
export const DELETE_SUCCESS = 'Entity/Roles/DELETE_SUCCESS'
export const DELETE_FAILURE = 'Entity/Roles/DELETE_FAILURE'
